<template>
    <select v-model="selectedYear" @change.stop="selectServiceYear()">
        <option
            v-for="year in years"
            :key="year.serviceYear"
            :value="year.serviceYear"
        >
            {{ formatDateToYear(year.startDate) }}-{{
                formatDateToYear(year.endDate)
            }}
        </option>
    </select>
</template>
<script>
export default {
    name: 'RockYearSelection',
    props: ['years', 'selected'],
    data() {
        return {
            selectedYear: -1
        };
    },
    created: function () {
        this.selectedYear = this.selected.serviceYear;
    },
    methods: {
        selectServiceYear: function () {
            this.$emit('change', this.selectedYear);
        },
        formatDateToYear: function (date) {
            const formatedDate = new Date(date);
            return formatedDate.getFullYear();
        }
    }
};
</script>
